export enum ReleaseNoteCategory {
  'NewFeature' = 1,
  'Improvements' = 2,
  'API' = 3,
  'Device' = 4,
  'Security' = 5,
  'WebApp' = 6,
  'Performance' = 7,
  'BugFixes' = 8,
  'UX' = 9,
}

export const ReleaseNoteCategoryDisplay: Record<ReleaseNoteCategory, string> = {
  [ReleaseNoteCategory.NewFeature]: 'New Features',
  [ReleaseNoteCategory.Improvements]: 'Improvements',
  [ReleaseNoteCategory.API]: 'API',
  [ReleaseNoteCategory.Device]: 'Device',
  [ReleaseNoteCategory.Security]: 'Security',
  [ReleaseNoteCategory.WebApp]: 'Web App',
  [ReleaseNoteCategory.Performance]: 'Performance',
  [ReleaseNoteCategory.BugFixes]: 'Bug Fixes',
  [ReleaseNoteCategory.UX]: 'UX',
};
